import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';

const styles = {
  borderRadius: '50%',
  width: 48,
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  textTransform: 'uppercase',
  fontSize: '1.5rem',
};

const PLATFORM_COLORS = {
  youtube: {
    backgroundColor: '#FF0000',
    color: '#FFFFFF',
    initials: 'YT'
  },
  instagram: {
    backgroundColor: '#E8424E',
    color: '#FFFFFF',
    initials: 'IG'
  }
};

const BLUE_GRADIENT = 'linear-gradient(135deg, #7BB7F0 0%, #4A90D9 50%, #2E6FB8 100%)';

const UserThumbnail = ({
  imageUrl,
  initials,
  backgroundColor,
  color,
  platform = 'youtube',
  gradient = false,
  size = 'md'
}) => {
  const customStyles = { ...styles };
  switch (size) {
    case 'sm':
      customStyles.width = 32;
      customStyles.height = 32;
      customStyles.fontSize = '1rem';
      break;
    case 'lg':
      customStyles.width = 64;
      customStyles.height = 64;
      break;
    case 'xl':
      customStyles.width = 100;
      customStyles.height = 100;
      break;
    case 'xll':
      customStyles.width = 150;
      customStyles.height = 150;
      customStyles.fontSize = '2rem';
      break;
    case 'md':
    default:
      customStyles.width = 48;
      customStyles.height = 48;
      break;
  }

  if (imageUrl) return <Image src={imageUrl} roundedCircle style={customStyles} />;

  if (gradient) {
    return <div className='user-thumbnail' style={{
      ...customStyles,
      background: BLUE_GRADIENT,
      color: '#FFFFFF',
    }}>
      {initials ? initials.substr(0, 2) : ''}
    </div>;
  }

  const colors = PLATFORM_COLORS[platform] || {
    color,
    backgroundColor,
  };
  return <div className='user-thumbnail' style={{
    ...customStyles,
    ...colors
  }}>
    {initials ? initials.substr(0, 2) : PLATFORM_COLORS[platform].initials}
  </div>;
};

UserThumbnail.propTypes = {
  imageUrl: PropTypes.string,
  initials: PropTypes.string,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  platform: PropTypes.string,
  gradient: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xll']),
};

export default React.memo(UserThumbnail);